/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.bundles.rpc.BundleRpc
 */

export const createBundleRpc = {
  serviceName: 'com.hubspot.product.bundles.rpc.BundleRpc',
  rpcName: 'createBundle',
  auth: 'app',
  fingerprint: 'L_piRJiPAOObYrGXhN5pCH5gTgiUWrab',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateBundleRpc = {
  serviceName: 'com.hubspot.product.bundles.rpc.BundleRpc',
  rpcName: 'updateBundle',
  auth: 'app',
  fingerprint: 'lMLqyrGFsP915p3ADobZs35gTgiUWrab',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateBundleItemRpc = {
  serviceName: 'com.hubspot.product.bundles.rpc.BundleRpc',
  rpcName: 'updateBundleItem',
  auth: 'app',
  fingerprint: 'U9hson5RLXM38nHXSOYtFX5gTgiUWrab',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBundleRpc = {
  serviceName: 'com.hubspot.product.bundles.rpc.BundleRpc',
  rpcName: 'getBundle',
  auth: 'app',
  fingerprint: 'NOZRxeeAFhHTX5PJgu6m935gTgiUWrab',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBundleItemsRpc = {
  serviceName: 'com.hubspot.product.bundles.rpc.BundleRpc',
  rpcName: 'getBundleItems',
  auth: 'app',
  fingerprint: 'E7-X6bVlc9PX9_y8C3WWs35gTgiUWrab',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};